import {
    FETCH_SCHEMES_PLAN_SUBOPTION_REQUEST,
    FETCH_SCHEMES_PLAN_SUBOPTION_SUCCESS,
    FETCH_SCHEMES_PLAN_SUBOPTION_FAILURE,
  } from "./FetchMedSchemePlanSubOptionsTypes";
  
  const initialState = {
    loading: false,
    schemesPlanSubOptions: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SCHEMES_PLAN_SUBOPTION_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_SCHEMES_PLAN_SUBOPTION_SUCCESS:
        return {
          loading: false,
          schemesPlanSubOptions: action.payload,
          error: "",
        };
      case FETCH_SCHEMES_PLAN_SUBOPTION_FAILURE:
        return {
          loading: false,
          schemesPlanSubOptions: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  